import React, { useContext } from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@clientbase/clientbase-library'
import { Box } from '@mui/material'
import * as S from 'templates/Invoice/components/InvoiceTable/InvoiceTable.styles'

import { Table } from 'components/Table'

import { formatDate } from 'utils/FormatDate'
import { formatMoney } from 'utils/FormatMoney'

import { theme } from 'styles/theme'

import { ModalChargeDetailContext } from '../../context'
import { cardTittle } from '../../ModalChargeDetail.utils'

// Mesmos rótulos usados na listagem de NFSe (InvoiceTable.mapper / .styles).
const STATUS_LABEL: Record<string, string> = {
  pending: 'Pendente',
  issued: 'Processando',
  confirmed: 'Emitida',
  canceled: 'Cancelada',
  failed: 'Falhada'
}

const Nfses: React.FC = () => {
  const { invoice } = useContext(ModalChargeDetailContext)

  if (!invoice?.nfses || invoice.nfses.length === 0) {
    return null
  }

  const rows = invoice.nfses.map((nfse) => ({
    number: nfse.nfse_number || '—',
    dateEmited: nfse.nfse_item?.created_at
      ? formatDate(nfse.nfse_item.created_at)
      : '—',
    amount:
      nfse.nfse_item?.amount != null ? formatMoney(nfse.nfse_item.amount) : '—',
    status: {
      component: (
        <S.Status status={nfse.status}>
          {STATUS_LABEL[nfse.status] || nfse.status}
        </S.Status>
      )
    }
  }))

  return (
    <Accordion
      sx={{
        border: '1px solid #E8EBE8',
        borderLeft: '3px solid',
        borderLeftColor: 'primary.main',
        borderRadius: '8px !important',
        backgroundColor: '#FAFBFA',
        boxShadow: 'none',
        '&:before': { display: 'none' },
        '&.Mui-expanded': { margin: 0, backgroundColor: '#fff' }
      }}
    >
      <AccordionSummary aria-controls="nfses-content" id="nfses">
        {cardTittle(
          'Notas fiscais',
          'description',
          `${theme.palette.primary.main}`
        )}
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            width: '100%',
            [theme.breakpoints.down(450)]: {
              maxWidth: '40vh'
            }
          }}
        >
          <Table
            mobileCards
            header={[
              { id: 'number', label: 'Número da Nota' },
              { id: 'dateEmited', label: 'Data Emissão' },
              { id: 'amount', label: 'Valor' },
              { id: 'status', label: 'Status' }
            ]}
            rows={rows}
            select={{ useSelect: false }}
            hiddePagination
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default Nfses
